import { cn } from "@/lib/utils";

interface BrandLogoProps {
  className?: string;
  markClassName?: string;
  textClassName?: string;
  compact?: boolean;
  stacked?: boolean;
}

export function BrandLogo({
  className,
  markClassName,
  textClassName,
  compact = false,
  stacked = true,
}: BrandLogoProps) {
  return (
    <div className={cn("flex min-w-0 items-center gap-2.5", className)}>
      <img
        src="/logo.svg"
        alt=""
        aria-hidden="true"
        className={cn("h-9 w-9 shrink-0", markClassName)}
      />
      {!compact && (
        <span
          className={cn(
            "min-w-0 leading-none text-gray-950 dark:text-white",
            textClassName,
          )}
        >
          {stacked ? (
            <>
              <span className="block truncate text-base font-semibold">
                AI Academy
              </span>
              <span className="block text-[10px] font-semibold uppercase text-blue-600 dark:text-cyan-300">
                Pro
              </span>
            </>
          ) : (
            <span className="block truncate text-sm font-semibold sm:text-base">
              AI Academy <span className="text-blue-600 dark:text-cyan-300">Pro</span>
            </span>
          )}
        </span>
      )}
    </div>
  );
}
